import React from 'react';
import {
    CountryFlag,
    DateIcon,
    NavItemStyled,
    Sign,
    SignWrapper,
    SportIcon,
    SportImg,
} from '../styled';
import { getIconName, getIconPath, getCountryName } from '../helper';
import moment from 'moment/moment';
import {
    ANOTHER_SPORTS_ID,
    APP_PATH,
    DANMARK_ID,
    LIVE_CASINO,
    ANBEFALET,
    ANBEFALET_SPORT_ID,
    LIVE_ID,
    REST_EUROPE_ID,
    REST_WORLD_ID,
    SOON_ID,
    BIG_NINE,
    COUNTRIES_IMG,
} from 'constants/appConfig';

const HorizontalNavigationItem = ({
    item,
    selectedId,
    selectedSport,
    onClickHandler,
    showWhiteItems,
}) => {
    const isActive = selectedId !== 'none' && selectedId === item.id.toString();
    const isLongTitle =
        item.name.includes(' ') &&
        ![
            SOON_ID,
            LIVE_CASINO,
            BIG_NINE,
            ANBEFALET,
            ANOTHER_SPORTS_ID,
        ].includes(item.id);

    const getCountryIcon = (data) => {
        const countryName = getCountryName(data);

        if (
            COUNTRIES_IMG.indexOf(countryName.toLowerCase()) > -1 ||
            countryName.toLowerCase() === 'brasilien'
        ) {
            return (
                <CountryFlag
                    src={
                        APP_PATH +
                        '/img/sports/' +
                        countryName.toLowerCase() +
                        '.png'
                    }
                    className="country-flag"
                    width="20"
                    height="20"
                    alt={countryName}
                />
            );
        } else {
            return null;
        }
    };

    return (
        <NavItemStyled
            $live={item.id === LIVE_ID}
            $isActive={isActive}
            $showWhiteItems={showWhiteItems}
            onClick={() => onClickHandler(item)}
            className="nav-item"
        >
            <SportIcon className="sport-icon">
                <SportImg
                    src={getIconPath(item, selectedSport)}
                    alt={item.name}
                    className="fallback-svg"
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = APP_PATH + '/img/bet25sport_icon.svg';
                        e.target
                            .closest('.sport-icon')
                            .classList.add('sport-icon-error');
                    }}
                    $isActive={isActive}
                    $isYellowIcon={item.id === ANBEFALET_SPORT_ID}
                />
                {selectedSport &&
                ((item.id > 0 &&
                    [
                        LIVE_CASINO,
                        ANBEFALET,
                        BIG_NINE,
                        LIVE_ID,
                        SOON_ID,
                    ].indexOf(item.id) === -1) ||
                    [DANMARK_ID, REST_EUROPE_ID, REST_WORLD_ID].indexOf(
                        item.id
                    ) > -1)
                    ? getCountryIcon(item)
                    : ''}
                {item.id !== SOON_ID ? null : (
                    <DateIcon>{moment().format('DD')}</DateIcon>
                )}
            </SportIcon>
            <SignWrapper>
                <Sign $fontSize={isLongTitle && '9px'}>
                    {getIconName(item)}
                </Sign>
            </SignWrapper>
        </NavItemStyled>
    );
};

export default HorizontalNavigationItem;
